import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=22101c36&scoped=true"
import script from "./VideoDetails.vue?vue&type=script&lang=js"
export * from "./VideoDetails.vue?vue&type=script&lang=js"
import style0 from "./VideoDetails.vue?vue&type=style&index=0&id=22101c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22101c36",
  null
  
)

export default component.exports